import React, { useState } from 'react'
import styled from 'styled-components'
import SessionDialog from './SessionDialog'

const Field = styled.div`
  margin-bottom: 14px;
`
const Label = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: ${(p) => p.theme?.color?.inkMuted || '#6B7280'};
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 4px;
`
const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
  &:focus {
    outline: 2px solid ${(p) => p.theme?.color?.primary || '#1F3A5F'};
    outline-offset: 1px;
  }
`
const TextArea = styled.textarea`
  width: 100%;
  min-height: 70px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  &:focus {
    outline: 2px solid ${(p) => p.theme?.color?.primary || '#1F3A5F'};
    outline-offset: 1px;
  }
`

export default function RequestSessionDialog({
  open,
  onClose,
  onSubmit,
  defaultPractitionerId,
  defaultPractitionerName,
}) {
  const [practitionerId, setPractitionerId] = useState(defaultPractitionerId || '')
  const [reason, setReason] = useState('')
  const [preferred, setPreferred] = useState('')
  const [busy, setBusy] = useState(false)

  async function handleSubmit() {
    setBusy(true)
    try {
      await onSubmit({
        practitionerId: practitionerId.trim(),
        reason: reason.trim() || null,
        preferredSlots: preferred
          .split(/[,\n]+/)
          .map((s) => s.trim())
          .filter(Boolean),
      })
      onClose()
    } finally {
      setBusy(false)
    }
  }

  return (
    <SessionDialog
      open={open}
      title={defaultPractitionerName ? `Request session with ${defaultPractitionerName}` : 'Request a session'}
      subtitle="Your practitioner will pick a slot from your preferences and confirm."
      primaryLabel="Send request"
      primaryDisabled={!practitionerId.trim()}
      onPrimary={handleSubmit}
      primaryLoading={busy}
      onClose={onClose}
    >
      {!defaultPractitionerId && (
        <Field>
          <Label>Practitioner</Label>
          <Input
            value={practitionerId}
            onChange={(e) => setPractitionerId(e.target.value)}
            placeholder="Practitioner id"
          />
        </Field>
      )}
      <Field>
        <Label>Preferred times (free-text)</Label>
        <Input
          value={preferred}
          onChange={(e) => setPreferred(e.target.value)}
          placeholder="e.g. Tue 5pm, Wed mornings"
        />
      </Field>
      <Field>
        <Label>Reason (optional)</Label>
        <TextArea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Anything your practitioner should know ahead of time"
        />
      </Field>
    </SessionDialog>
  )
}
